import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  return (
    <main>
      <Header />
      <div className="lms-body-wrapper">
        <div className="lms-container">
          <Outlet />
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default AdminLayout;
